<template>
  <div class="content">
    <div class="holder container">
      <ValidationObserver ref="form">
        <form @submit.prevent="updateOrder" method="POST" action>
          <div class="content-body col-md-10 col-xl-7 col-12 p-0">
            <div class="form-group row-text-index">
              <span
                class="font-weight-bold"
              >{{$t('front_end.a070.label.order_number')}} : {{order.orderNo}}</span>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{$t('front_end.a070.label.name')}}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <div class="col-5 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a070.placeholder.first_name')"
                    rules="required|full_size|max:255"
                    v-slot="{ errors }"
                    class="width-inherit"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a070.placeholder.first_name')"
                      v-model.trim="order.ordererLastName"
                    />
                    <span class="error-msg message-error-size">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="col-5 offset-2 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a070.placeholder.last_name')"
                    rules="required|full_size|max:255"
                    v-slot="{ errors }"
                    class="width-inherit"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a070.placeholder.last_name')"
                      v-model.trim="order.ordererFirstName"
                    />
                    <span class="error-msg message-error-size">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="error-msg message-error-size">{{errors.name}}</div>
              </div>
            </div>

            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{$t('front_end.a070.label.name_furigana')}}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <div class="col-5 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a070.placeholder.first_name_furigana')"
                    rules="required|max:255|full_size_katakana"
                    v-slot="{ errors }"
                    class="width-inherit"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a070.placeholder.first_name_furigana')"
                      v-model.trim="order.kanaLastName"
                    />
                    <span class="error-msg message-error-size">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="col-5 offset-2 none-padding">
                  <ValidationProvider
                    mode="passive"
                    :name="$t('front_end.a070.placeholder.last_name_furigana')"
                    rules="required|max:255|full_size_katakana"
                    v-slot="{ errors }"
                    class="width-inherit"
                  >
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('front_end.a070.placeholder.last_name_furigana')"
                      v-model.trim="order.kanaFirstName"
                    />
                    <span class="error-msg message-error-size">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="error-msg message-error-size">{{errors.nameKana}}</div>
              </div>
            </div>

            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{$t('front_end.a070.label.email')}}</span>
                <span class="text-danger" v-if="!isShopMode">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a070.label.email')"
                  rules="required|email|max:254"
                  v-slot="{ errors, failedRules }"
                  class="custom-mail"
                  v-if="!isShopMode"
                >
                  <input type="text" class="form-control" v-model.trim="order.mailAddress" />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.email"
                  >{{$t('front_end.a070.validate.email_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider
                  mode="passive"
                  :name="$t('front_end.a070.label.email')"
                  rules="email|max:254"
                  v-slot="{ errors, failedRules }"
                  class="custom-mail"
                  v-else
                >
                  <input type="text" class="form-control" v-model.trim="order.mailAddress" />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.email"
                  >{{$t('front_end.a070.validate.email_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{$t('front_end.a070.label.phone_number')}}</span>
                <span class="text-danger">*</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberFirst"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|min:2|max:5|half_size|numeric"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{ errors, failedRules }"
                >
                  <input
                    :type="isMobile ? 'number':'text'"
                    class="form-control text-center pd-0 auto-next"
                    v-model.trim="order.phone1"
                    id="phone_number_first"
                    maxlength="5"
                    :pattern="dynamicPattern"
                  />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.min || failedRules.max"
                  >{{$t('front_end.a070.validate.length_phone')}}</span>
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.numeric || failedRules.half_size"
                  >{{$t('front_end.a070.validate.phone_number_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </ValidationProvider>
                <span class="line-zip"></span>
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberSecond"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|min:1|max:4|half_size|numeric"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{ errors, failedRules }"
                >
                  <input
                    :type="isMobile ? 'number':'text'"
                    class="form-control text-center pd-0 auto-next"
                    v-model.trim="order.phone2"
                    id="phone_number_second"
                    maxlength="4"
                    :pattern="dynamicPattern"
                  />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.min || failedRules.max"
                  >{{$t('front_end.a070.validate.length_phone')}}</span>
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.numeric || failedRules.half_size"
                  >{{$t('front_end.a070.validate.phone_number_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </ValidationProvider>
                <span class="line-zip"></span>
                <ValidationProvider
                  mode="passive"
                  vid="phoneNumberThird"
                  :name="$t('front_end.a095.phone_number')"
                  rules="required|min:1|max:4|half_size|numeric"
                  class="col-3 col-md-3 pd-0"
                  v-slot="{ errors, failedRules}"
                >
                  <input
                    :type="isMobile ? 'number':'text'"
                    class="form-control text-center pd-0 auto-next"
                    v-model.trim="order.phone3"
                    id="phone_number_third"
                    :pattern="dynamicPattern"
                    maxlength="4"
                  />
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.min || failedRules.max"
                  >{{$t('front_end.a070.validate.length_phone')}}</span>
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.numeric || failedRules.half_size"
                  >{{$t('front_end.a070.validate.phone_number_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="error-msg message-error-size" v-if="isPhoneError">{{errors.phoneNumber}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="row-custom mb-2">
                <div class="col-2">
                  <span>{{$t('front_end.a070.label.ship_address.ship_address')}}</span>
                </div>
                <div class="col-10 pr-0">
                  <span>{{$t('front_end.a070.label.ship_address.postal_code')}}</span>
                  <span class="text-danger" v-if="!isShopMode">*</span>
                </div>
              </div>
              <ValidationProvider
                v-if="!isShopMode"
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.postal_code')"
                rules="required|half_size|numeric|length:7"
                v-slot="{ errors, failedRules }"
                ref="postalCode"
              >
                <div class="row col-10 pr-0 offset-2">
                  <input
                    :type="isMobile ? 'number':'text'"
                    class="form-control col-5"
                    v-model.trim="order.postalCode"
                    :pattern="dynamicPattern"
                    id="zip-code"
                    maxlength="7"
                  />
                  <a
                    class="btn btn-custom"
                    @click="searchAddress()"
                  >{{$t('front_end.a070.button.automatic_input_code')}}</a>
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.length"
                  >{{$t('front_end.a070.validate.length_postal_code')}}</span>
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.half_size || failedRules.numeric "
                  >{{$t('front_end.a070.validate.zip_code_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.postal_code')"
                rules="half_size|numeric|length:7"
                v-slot="{ errors, failedRules }"
                ref="postalCode"
              >
                <div class="row col-10 pr-0 offset-2">
                  <input
                    :type="isMobile ? 'number':'text'"
                    class="form-control col-5"
                    v-model.trim="order.postalCode"
                    id="zip-code"
                    :pattern="dynamicPattern"
                    maxlength="7"
                  />
                  <a
                    class="btn btn-custom"
                    @click="searchAddress()"
                  >{{$t('front_end.a070.button.automatic_input_code')}}</a>
                  <span
                    class="error-msg message-error-size"
                    v-if="failedRules.length"
                  >{{$t('front_end.a070.validate.length_postal_code')}}</span>
                  <span
                    class="error-msg message-error-size"
                    v-else-if="failedRules.half_size || failedRules.numeric "
                  >{{$t('front_end.a070.validate.zip_code_format')}}</span>
                  <span class="error-msg message-error-size" v-else>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                v-if="!isShopMode"
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.prefectures')"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.prefectures')}}</label>
                  <span class="text-danger">*</span>
                  <div class="select-box">
                    <font-awesome-icon icon="angle-down" class="icon-select" />
                    <select class="form-control pt-0 pb-0" v-model="order.prefectures">
                      <option
                        v-for="(pref, index) in prefectureList"
                        :key="index"
                        :selected="pref === order.prefectures"
                      >{{pref}}</option>
                    </select>
                  </div>
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <div v-else class="row col-10 pr-0 offset-2">
                <label>{{$t('front_end.a070.label.ship_address.prefectures')}}</label>
                <div class="select-box">
                  <font-awesome-icon icon="angle-down" class="icon-select" />
                  <select class="form-control pt-0 pb-0" v-model="order.prefectures">
                    <option
                      v-for="(pref, index) in prefectureList"
                      :key="index"
                      :selected="pref === order.prefectures"
                    >{{pref}}</option>
                  </select>
                </div>
                <span class="error-msg message-error-size">{{ errors[0] }}</span>
              </div>
            </div>
            <div class="form-group">
              <ValidationProvider
                v-if="!isShopMode"
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.city')"
                rules="required|full_size|max:100"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.city')}}</label>
                  <span class="text-danger">*</span>
                  <input type="text" class="form-control" v-model.trim="order.city" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.city')"
                rules="full_size|max:100"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.city')}}</label>
                  <input type="text" class="form-control" v-model.trim="order.city" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                v-if="!isShopMode"
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.address_number')"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.address_number')}}</label>
                  <span class="text-danger" v-if="!isShopMode">*</span>
                  <input type="text" class="form-control" v-model.trim="order.streetAddress1" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-else
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.address_number')"
                rules="max:255"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.address_number')}}</label>
                  <input type="text" class="form-control" v-model.trim="order.streetAddress1" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                mode="passive"
                :name="$t('front_end.a070.label.ship_address.building_name')"
                rules="max:255"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <label>{{$t('front_end.a070.label.ship_address.building_name')}}</label>
                  <input type="text" class="form-control" v-model.trim="order.streetAddress2" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                mode="passive"
                :name="$t('front_end.a070.label.company_name')"
                rules="max:255"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <span>{{$t('front_end.a070.label.company_name')}}</span>
                  <input type="text" class="form-control" v-model.trim="order.companyName" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider
                mode="passive"
                :name="$t('front_end.a070.label.department_name')"
                rules="max:255"
                v-slot="{ errors }"
              >
                <div class="row col-10 pr-0 offset-2">
                  <span>{{$t('front_end.a070.label.department_name')}}</span>
                  <input type="text" class="form-control" v-model.trim="order.departmentName" />
                  <span class="error-msg message-error-size">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-group row-custom">
              <div class="col-2">
                <span>{{$t('front_end.a070.label.comment')}}</span>
              </div>
              <div class="row-custom col-10 pr-0">
                <textarea rows="3" class="form-control" v-model.trim="order.comment"></textarea>
              </div>
            </div>
          </div>
          <div class="content-footer-info">
            <button class="col-md-4 col-5 btn-footer">{{$t('front_end.a070.button.change')}}</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- confirm -->
    <div class="modal modal-dialog-wrapper" v-show="isShowConfirm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="close-dialog pb-0" @click="isShowConfirm = false">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="times-circle"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="icon-close svg-inline--fa fa-times-circle fa-w-16"
            >
              <path
                fill="currentColor"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                class
              />
            </svg>
          </div>
          <div class="dialog-content border-0">
            <div class="modal-body dialog-body">
              <div class="form-group text-center cursor-default mb-25">
                <span v-html="messageConfirm">{{messageConfirm}}</span>
              </div>
            </div>
          </div>
          <div class="text-center row m-0">
            <a
              class="btn btn-dialog col-6 border-top border-right"
              @click="onUpdate()"
            >{{buttonConfirm}}</a>
            <a
              class="btn btn-dialog col-6 border-top border-left"
              @click="isShowConfirm = false"
            >{{buttonCancel}}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- base alert -->
    <fe-alert ref="updateSuccess" :datas="updateSuccess">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <div class="mt-4" v-html="$t('front_end.a070.alert.alert_success')" />
          <button
            type="button"
            class="btn-dialog btn-link-dialog pb-0"
            @click="onClickLink()"
          >{{ 
              isShopMode
              ? $t("front_end.a070.alert.alert_success_link")
              : $t("front_end.a070.alert.alert_success_link_select_payment")
            }}
          </button>
        </div>
      </template>
    </fe-alert>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import apiService from "@/services/api";
import apiEndpoints from "@/services/apiEndpoints";
import FeAlert from "@/components/fe/common/FeAlert";
import deviceUtil from "../../utils/deviceUtil";
import _ from "lodash";

export default {
  name: "a070",
  components: {
    ValidationProvider,
    ValidationObserver,
    FeAlert
  },

  data() {
    return {
      isComplete: false,
      isShowConfirm: false,
      messageComplete: this.$t("front_end.a070.message_complete"),
      nameButtonDialog: this.$t("front_end.a070.message_back_order"),
      messageConfirm: this.$t("front_end.a070.confirm_message"),
      buttonConfirm: this.$t("front_end.a070.yes"),
      buttonCancel: this.$t("front_end.a070.cancel"),
      order: {
        orderNo: "",
        ordererFirstName: "",
        ordererLastName: "",
        mailAddress: "",
        kanaFirstName: "",
        kanaLastName: "",
        phone1: "",
        phone2: "",
        phone3: "",
        postalCode: "",
        city: "",
        prefectures: "",
        streetAddress1: "",
        streetAddress2: "",
        companyName: "",
        departmentName: "",
        comment: ""
      },
      prefectureList: [],
      errors: {
        name: "",
        nameKana: "",
        email: "",
        phoneNumber: "",
        zipCode: "",
        prefecture: "",
        city: "",
        address: ""
      },
      isShopMode: false,
      shopId: "",
      updateSuccess: {
        isShow: false,
        isShowClose: false,
        opts: {
          keyboard: false,
          backdrop: "static"
        }
      },
      isPhoneError: false,
      isMobile: !deviceUtil.isPc()
    };
  },
  computed: {
    ...mapGetters(["shopMode", "userData"]),
    phoneNumber() {
      return this.order.phone1 + this.order.phone2 + this.order.phone3;
    },
    dynamicPattern() {
      return deviceUtil.isiOS() ? "\\d*" : ".*";
    }
  },
  created() {
    this.isShopMode = this.shopMode.shopName ? true : false;
    if (this.isShopMode) {
      this.shopId = this.shopMode.shopId;
    }
    this.prefectureList = this.$configFe.prefectures;
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === "input") {
        e.preventDefault();
      }
    });
  },
  mounted() {
    if (this.userData.order.ordererInformation) {
      this.order = _.cloneDeep(this.userData.order.ordererInformation);
    }
    this.$root.$on('header-back', this.backBtnHandle)
  },
  beforeDestroy() {
    this.$root.$off('header-back', this.backBtnHandle)
  },
  methods: {
    backBtnHandle() {
      this.$router.push({ name: this.isShopMode ? 'a065' : 'a125' })
    },
    async updateOrder() {
      let isValidPhone = this.checkPhoneIsValid();
      let isValid = await this.validateForm();
      if (!isValid || !isValidPhone) {
        return "";
      }
      this.isShowConfirm = true;
    },
    async validateForm() {
      this.isPhoneError = !this.checkPhoneIsValid();
      let isValid = await this.$refs["form"].validate();
      return isValid || this.isPhoneError;
    },
    checkPhoneIsValid() {
      if (this.phoneNumber.length < 10 || this.phoneNumber.length > 11) {
        this.errors.phoneNumber = this.$t(
          "front_end.a070.validate.phone_number_limit"
        );
        return false;
      }
      return true;
    },
    async onUpdate() {
      let url = apiEndpoints.inputOrdererInformation;
      let ordererInformation = this.order;
      let actionType = "modification";
      try {
        let result = await apiService.post(url, {
          ordererInformation: ordererInformation,
          actionType: actionType
        });
        if (result && result.status == 200) {
          this.$store.commit("userData/SET_ORDER", {
            ordererInformation: ordererInformation
          });
          this.isShowConfirm = false;
          this.$refs.updateSuccess.show();
        }
      } catch (e) {
        //
      }
    },
    async searchAddress() {
      let isValid = this.$refs.postalCode.validate();
      if (!isValid) {
        return;
      }

      if (this.order.postalCode.length === 7) {
        try {
          let result = await apiService.post(apiEndpoints.searchAddress, {
            postalCode: this.order.postalCode
          });
          if (result && result.data) {
            this.order.city = result.data.address.city;
            this.order.prefectures = result.data.address.prefectures;
            this.order.streetAddress1 = result.data.address.townArea;
          }
        } catch (e) {
          //
        }
      }
    },
    onConfirmOk() {
      if (this.typeAlert == "success") {
        this.onClickLink();
      }
    },
    onClickLink() {
      this.$refs.updateSuccess.hide();
      this.$router.push({ name: this.isShopMode ? "a065" : "a125" });
    }
  }
};
</script>

<style lang="css" scoped src="../../assets/css/userInfoOrder/userInfoOrder.css"></style>
<style scoped>
.pd-0 {
  padding: 0px !important;
}

.icon-select {
  color: #dd0017;
  position: absolute;
  right: 0;
  font-size: 15px;
  top: 0;
  height: 100%;
  margin: 0 7px;
  pointer-events: none;
}

.btn-custom {
  max-height: 37px;
  line-height: 22px;
  min-width: 100px;
  margin-right: 10px;
}

.btn-custom:hover {
  color: #fff;
}

.cursor-default {
  padding: 15px 0;
}

.btn-link-dialog {
  border: 1px solid #333;
  padding: 5px !important;
  border-radius: 5px;
  margin-top: 30px;
}

.close-dialog{
  padding: 10px;
}

.close-dialog svg {
  width: 20px;
  height: 20px;
}
.message-error-size,
.inline-error-noti,
.message-error {
  margin: 0px;
  font-size: 12px;
}

.form-control{
  font-size: 0.9rem !important;

}
@media screen and (min-width: 768px) {
  .icon-select {
    font-size: 20px;
    margin: 0 10px;
  }
}

@media screen and (min-width: 1024px) {
  .icon-select {
    font-size: 25px;
  }
}

@media screen and (max-width: 480px) {
  .btn-custom {
    padding: 5px;
    max-height: 33px;
  }
}
</style>
